import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import './styles.scss';

const ButtonAlert = ({ classNames = [], ...props }) => (
    <Button {...props} classNames={['custom-btn-alert', ...classNames]} />
);

ButtonAlert.propTypes = {
    classNames: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func,
};

export default ButtonAlert;
